import { BaseButton, BaseDialog } from '@/shared/components'
import { ChevronRight } from 'lucide-react'
import { DepositInfoPanel } from '@/features/sidebar/dialogs/DepositInfoPanel.tsx'

type Props = {
  isVisible: boolean
  onClose: () => void
  onTopup: () => void
  onWithdraw: () => void
}

export const ActionsDialog = ({ isVisible, onClose, onTopup, onWithdraw }: Props) => {
  return (
    <BaseDialog isVisible={isVisible} onClose={onClose} title="Действия с балансом">
      <BaseButton
        variant="outlined"
        className="rounded-lg !text-text-secondary !justify-between !px-3"
        onClick={onTopup}
        icon={<ChevronRight />}
        iconPosition="right"
      >
        Пополнить
      </BaseButton>
      <BaseButton
        variant="outlined"
        className="rounded-lg !text-text-secondary !justify-between !px-3"
        onClick={onWithdraw}
        icon={<ChevronRight />}
        iconPosition="right"
      >
        Вывести
      </BaseButton>

      <DepositInfoPanel />

    </BaseDialog>
  )
}
